import { Grid, TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';

export const StyledGridContainer = styled(Grid)`
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  padding: 15px 15px 10px 10px;
  padding-top: 5px;
`;

export const StyledTableCell = styled(TableCell)`
  border: 0;
`;